export default __webpack_public_path__ + "static/media/mei-intro.266e07ac.mp3";